package dev.akshaychordiya.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toModifier
import dev.akshaychordiya.MetaTextStyle
import dev.akshaychordiya.content.Site
import dev.akshaychordiya.toSitePalette
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px

val FooterStyle = CssStyle.base {
    Modifier
        .borderTop(1.px, LineStyle.Solid, colorMode.toSitePalette().border)
        .padding(topBottom = 2.5.cssRem, leftRight = 1.5.cssRem)
        .margin(top = 4.cssRem)
}

val FooterLinkStyle = CssStyle {
    base { Modifier.fontSize(0.9.cssRem).color(colorMode.toSitePalette().subdued) }
    hover { Modifier.color(colorMode.toSitePalette().brandPrimary) }
}

/** Read from the browser at render time so the copyright never silently goes stale. */
private fun currentYear(): Int = kotlin.js.Date().getFullYear()

@Composable
fun Footer(modifier: Modifier = Modifier) {
    Column(
        FooterStyle.toModifier().then(modifier),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Row(
            Modifier
                .gap(1.25.cssRem)
                .flexWrap(FlexWrap.Wrap)
                .justifyContent(JustifyContent.Center),
        ) {
            Site.socials.forEach { social ->
                Link(
                    social.url,
                    social.label,
                    FooterLinkStyle.toModifier(),
                    variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
                )
            }
        }

        SpanText(
            "© ${currentYear()} ${Site.NAME}",
            MetaTextStyle.toModifier().margin(top = 1.25.cssRem).textAlign(TextAlign.Center),
        )

        SpanText(
            "Built with Kotlin and Kobweb",
            MetaTextStyle.toModifier().margin(top = 0.35.cssRem).textAlign(TextAlign.Center),
        )
    }
}
